// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bFhi","top":"styles_top__3xU6s","left":"styles_left__15-ZF","description":"styles_description__P3620"};